import React from "react";

// V4 brand mark: a pine ring with a centre dot and a single amber "resurfacing"
// dot sitting on the ring, paired with the Newsreader "Heldall" wordmark.
export function LogoMark({ size = 28 }) {
  return (
    <span
      className="relative inline-flex shrink-0"
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
        <circle cx="16" cy="16" r="11.5" stroke="var(--pine)" strokeWidth="2" />
        <circle cx="16" cy="16" r="2.4" fill="var(--pine)" />
        <circle cx="24" cy="9.2" r="2.6" fill="var(--amber)" />
      </svg>
    </span>
  );
}

export default function Logo({ size = 28, wordmark = true, className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-2.5 ${className}`}
      data-testid="brand-logo"
    >
      <LogoMark size={size} />
      {wordmark && (
        <span
          className="font-brand text-ink leading-none"
          style={{ fontSize: Math.round(size * 0.82), transform: "translateY(0.06em)" }}
        >
          Heldall
        </span>
      )}
    </span>
  );
}
